import type { Ref } from "react";
import React from "react";

import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";

export interface TagData {
  line: string;
  classes?: string;
  fontclasses?: string;
}

interface TagProps {
  data: TagData;
  ref?: Ref<HTMLSpanElement>;
}

/**
 * Renders a tag component with customizable text and styling.
 */
const Tag = ({ data, ref }: TagProps) => {
  const { line, classes, fontclasses = "" } = data || {};

  if (!line) {
    return null;
  }

  return (
    <span
      ref={ref}
      className={cn(
        "bg-nova-base-solid-20 inline-flex items-center justify-center rounded-sm w-fit whitespace-nowrap p-1.5 lg:p-2",
        classes
      )}
    >
      <TextElementNova
        text={line}
        element="span"
        className={cn(
          fontclasses.includes("CTA-") ? "" : "Caption-10-Dia-Uppercase",
          "leading-none h-[8px] translate-y-[-1px]", // forcefully align the text vertically in the tag
          fontclasses
        )}
      />
    </span>
  );
};

export default Tag;
